import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { CalamityActionHistoryService } from 'app/calamity/calamity-history.service';
import { CalamityService } from 'app/calamity/calamity.service';
import { CalamityActionNoteModel } from 'app/calamity/models/calamity-action-note.model';
import { CalamityActionModel } from 'app/calamity/models/calamity-action.model';
import { CalamityNoteModel } from 'app/calamity/models/calamity-note.model';
import { ActionsTypeService } from 'app/intake/actions/actions-type-service';
import { ActionContactWithService } from 'app/intake/actions/add-action/action-contact-with-service';
import { ActionStatutsService } from 'app/intake/actions/add-action/action-satuts-service';
import { IntakeService } from 'app/intake/intake-services/intake.service';
import { AgendaTypeService } from 'app/intake/note/agenda-type.service';
import { NoteTypeService } from 'app/intake/note/note-type.service';
import { MDMService } from 'app/reusable/mdm.service';
import { CONTACTS } from 'app/_constants/contacts';
import { UserProfile } from 'app/_models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrganisationUnitsSearchActionComponent } from '../../organisation-units-search-action/organisation-units-search-action.component';
import { CalamityActionService } from '../calamity-action.service';
import { ACTION_JSON } from 'app/_constants/actionJson';
import { CedNotificationService } from 'ced-ng-library';
import { MEDICAL_NOTES_FIELDES } from 'app/_constants/medical-notes-fields';

@Component({
  selector: 'app-add-calamity-action',
  templateUrl: './add-calamity-action.component.html',
  styleUrls: ['./add-calamity-action.component.scss']
})
export class AddCalamityActionComponent extends DialogContentBase implements OnInit {
  public calamityActionForm = new FormGroup({});
  private _subject$: Subject<void> = new Subject();
  public actionTypeValues = [];
  public contactValues = [];
  public managedByValues = [];
  public statusValues = [];
  public contactWithList = [];
  public agendaValues = [];
  public calamityActionToUpdate;
  public selectedCalamityAction ;
  public calamityId : string;
  public noteTypeList = [];
  public ListOfNotes: any = [];
  public calamityActionNotes = [];
  public latest_date: string;
  public date: Date;
  @Input() ouId: string;
  @Input() addAction: boolean;
  public notesExist: boolean = false;
  public closed: boolean = false;
  public actionHistoryList = [];
  yesNoList = [
    { id: 1, name: "Yes" },
    { id: 2, name: "No" },
  ]
  calamityAction = new CalamityActionModel();
  public profile: UserProfile = new UserProfile();

  constructor(dialog: DialogRef,
    private actionTypeService: ActionsTypeService,
    private actionContactWithService: ActionContactWithService,
    private mdmService: MDMService,
    private actionStatuts: ActionStatutsService,
    private agendaTypeService: AgendaTypeService,
    private translateService: TranslateService,
    private dialogService: DialogService,
    private cd: ChangeDetectorRef,
    private calamityService : CalamityService,
    private calamityActionService : CalamityActionService,
    private noteTypeService : NoteTypeService,
    private cedNotificationService: CedNotificationService,
    private calamityActionHistoryService : CalamityActionHistoryService,
    private intakeService: IntakeService,
    private datepipe: DatePipe) {
    super(dialog);
  }

  ngOnInit() {
    this.initAction();
    this.getCalamityId();
    this.initForm();
    this.getActualDate();
    this.calamityActionForm.controls["claAssociatedToHelpPlan"].disable();
    if (this.calamityActionToUpdate != undefined && this.calamityActionToUpdate != null){
      this.getCalamityActionById();
    }
    this.getNoteTypeListByRole();
  }

  initForm() {
    this.calamityActionForm = new FormGroup({
      claActionType: new FormControl(),
      claContactWith: new FormControl(),
      claOrganisation: new FormControl(),
      claAgenda: new FormControl(),
      claHelpPlan: new FormControl(),
      claAssociatedToHelpPlan: new FormControl(this.yesNoList[1]),
      claManagedBy: new FormControl(),
      claStatus: new FormControl(),
      claFollowUpDate: new FormControl(),
      claComment: new FormControl(""),
      claClosedDateAndTime: new FormControl(""),
    });
  }

  changeStatus(event) {
    if (event.dasShortName == "Closed") {
      this.closed = true;
      if(!this.notesExist){
        this.cedNotificationService.error("NOTIFICATIONS.NOTE_SHOULD_BE_ADDED")
      }
    }
  }

  notesList(event) {
    if (event != undefined) {
      this.ListOfNotes = event;
      this.notesExist = true;
    }
  }

  initAction(){
    this.actionTypeService
    .getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.actionTypeValues = data.sort((a, b) => a.atLongName.toLowerCase() > b.atLongName.toLowerCase() ? 1 : -1);
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ALL_CALAMITIES_ACTION_TYPES");
    }
    );
    this.actionContactWithService
    .getAll(true)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.contactValues = data.sort((a, b) => a.cwName.toLowerCase() > b.cwName.toLowerCase() ? 1 : -1);
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ALL_CALAMITIES_ACTION_CONTACTS");
    }
    );
    this.mdmService
    .getAccounts()
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      data = data.filter(e => (e.firstName != "" && e.lastName != "") && (e.firstName != null && e.lastName != null))
        this.managedByValues = data.sort((a, b) => a.lastName.toLowerCase() > b.lastName.toLowerCase() ? 1 : -1);
        this.managedByValues.forEach(el => el.fullName = el.firstName + " " + el.lastName);
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ALL_CALAMITIES_ACCOUNTS");
    }
    );
  this.actionStatuts.getAll(true)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.statusValues = data.sort((a, b) => a.dasShortName.toLowerCase() > b.dasShortName.toLowerCase() ? 1 : -1);
      if (this.calamityActionToUpdate == null) {
        this.calamityActionForm.controls["claStatus"].setValue(this.statusValues[1]);
      }
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ALL_CALAMITIES_ACTION_STATUS");
    }
    );
  this.agendaTypeService.getAgendaTypeByCulture(this.translateService.currentLang,true)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.agendaValues = data.sort((a, b) => a.ageShortName.toLowerCase() > b.ageShortName.toLowerCase() ? 1 : -1);
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_AGENDA_TYPE_BY_CULTURE");
    }
    );
    CONTACTS.forEach((element) => {
      this.contactWithList.push(this.translateService.instant(element.KEY));
    });
  }

  openDialog() {
    const dialogRef = this.dialogService.open({
      content: OrganisationUnitsSearchActionComponent,
    });
    dialogRef.result.subscribe((result: any) => {
      if (result != null) {
        this.calamityActionForm.controls.claOrganisation.setValue(result.longName);
        this.cd.detectChanges();
      }
    });
  }

  getCalamityActionById() {
    this.calamityActionService.getOneById(this.calamityActionToUpdate.claId)
    .pipe(takeUntil(this._subject$))
    .subscribe((data: any) => {
      this.selectedCalamityAction =data;
      this.calamityActionForm.controls["claActionType"].setValue(this.selectedCalamityAction.claActionType);
    this.calamityActionForm.controls["claStatus"].setValue(this.selectedCalamityAction.claStatus);
    this.calamityActionForm.controls["claFollowUpDate"].setValue(this.getDate(this.selectedCalamityAction.claFollowUpDate));
    if (this.selectedCalamityAction.claFreeText != null && this.selectedCalamityAction.claFreeText != undefined) {
      let otherItems = JSON.parse(this.selectedCalamityAction.claFreeText);
      this.selectedCalamityAction.claContactWith = otherItems.claContactWith;
      this.selectedCalamityAction.claAssociatedToHelpPlan = otherItems.claAssociatedToHelpPlan;
      this.selectedCalamityAction.claComment = otherItems.claComment;
      this.selectedCalamityAction.claAgenda = otherItems.claAgenda
      this.selectedCalamityAction.claOrganisation = otherItems.claOrganisation;
      this.selectedCalamityAction.claManagedBy = otherItems.claManagedBy;
      this.selectedCalamityAction.claClosedDateAndTime = otherItems.claClosedDateAndTime;
      this.calamityActionForm.controls["claComment"].setValue(this.selectedCalamityAction.claComment);
      this.calamityActionForm.controls["claOrganisation"].setValue(this.selectedCalamityAction.claOrganisation);
      this.calamityActionForm.controls["claContactWith"].setValue(this.selectedCalamityAction.claContactWith);
      let associatedToHelpPlan = this.yesNoList.find(v => v.name == this.selectedCalamityAction.claAssociatedToHelpPlan);
      if (associatedToHelpPlan != undefined) {
        this.calamityActionForm.controls["claAssociatedToHelpPlan"].setValue(associatedToHelpPlan);
      }
      this.calamityActionForm.controls["claAssociatedToHelpPlan"].updateValueAndValidity();
      this.calamityActionForm.controls["claAgenda"].setValue(this.selectedCalamityAction.claAgenda);
      this.calamityActionForm.controls["claManagedBy"].setValue(this.selectedCalamityAction.claManagedBy);
      this.calamityActionForm.controls["claClosedDateAndTime"].setValue(this.datepipe.transform(otherItems.claClosedDateAndTime, "MM-dd-yyyy HH:mm:ss"));
      this.calamityActionForm.controls["claHelpPlan"].setValue(this.selectedCalamityAction.claHelPlan);
      if (this.selectedCalamityAction.calamityActionNotes!=undefined && this.selectedCalamityAction.calamityActionNotes.length != 0) {
        this.calamityActionNotes = this.selectedCalamityAction.calamityActionNotes;
        this.notesExist = true;
      }
      this.ouId = this.selectedCalamityAction.claId;
    }
    this.cd.detectChanges();
    this.selectedCalamityAction.calamityActionLogHistories.forEach((element) => {
      try {
        let parseObject = JSON.parse(element.calFreeText);
        if (parseObject) {
          let actionHistory;
          if (parseObject.action == ACTION_JSON.ADD) {
            actionHistory = {
              user: parseObject.user,
              action: parseObject.action,
              field: "",
              old: "",
              new: "",
              date: this.datepipe.transform(this.getDate(parseObject.date), "MM-dd-yyyy HH:mm:ss")
            }
          }
          else {
            actionHistory = {
              user: parseObject.user,
              action: parseObject.action,
              field: parseObject.field,
              old: "from " + parseObject.oldvalue,
              new: "to " + parseObject.newvalue,
              date: this.datepipe.transform(parseObject.date, "MM-dd-yyyy HH:mm:ss")
            }
          }
          this.actionHistoryList.push(actionHistory);
          this.actionHistoryList = [...this.actionHistoryList];
          this.actionHistoryList.sort((a, b) => +new Date(a.date) - +new Date(b.date));
          this.cd.detectChanges();
        }
      }
      catch (e) {
        return false;
      }
    });
    this.cd.detectChanges();
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_ACTION_SERVICE_FOR_CALAMITY");
    }
    );
  }

  getDate(date){
    return this.getLocaleDate(date);
   }
   getLocaleDate(date: Date) {
     if(date!=null && (this.isIsoDate(date.toString()) ||  date.toString().indexOf('GMT') ==-1 ))
     {
       return this.intakeService.getLocalDate(date);
     }
     return date;
   }
   isIsoDate(dateStringToCompare) {
     return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
  }


  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this._subject$))
    .subscribe(res=> {
       this.calamityId=res;
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_BY_ID");
    });
  }

  getActualDate() {
    this.date = new Date();
    this.latest_date = this.datepipe.transform(this.date, 'yyyy-MM-dd HH:mm');
  }
  saveCalamityAction(calamityActionFormValue){
    if (calamityActionFormValue != undefined){
        this.executeActionCreation(calamityActionFormValue);
    }
  }

  private executeActionCreation = (calamityActionFormValue) => {
    this.calamityAction.claCalamityId = this.calamityId;
    this.calamityAction.claActionType = calamityActionFormValue.claActionType;
    this.calamityAction.claStatus = calamityActionFormValue.claStatus;
    if(calamityActionFormValue.claStatus.dasCode=="CLO"){
      this.calamityAction.claClosedDateAndTime = new Date();
    }
    let claFreeText = {
      claAssociatedToHelpPlan: "No",
      claComment: calamityActionFormValue.claComment,
      claContactWith: calamityActionFormValue.claContactWith,
      claOrganisation: calamityActionFormValue.claOrganisation,
      claAgenda: calamityActionFormValue.claAgenda,
      claHelpPlan: calamityActionFormValue.claHelpPlan,
      claManagedBy: calamityActionFormValue.claManagedBy,
      claClosedDateAndTime: this.calamityAction.claClosedDateAndTime
    };
    this.calamityAction.claFreeText = JSON.stringify(claFreeText);
    this.calamityAction.claFollowUpDate = calamityActionFormValue.claFollowUpDate;
    let index = 0;
    this.ListOfNotes.forEach(note => {
      this.calamityAction.calamityActionNotes[index] = new CalamityActionNoteModel();
      this.calamityAction.calamityActionNotes[index].canLastModifiedDate = new Date();
      this.calamityAction.calamityActionNotes[index].canCreatedDate = new Date();
      this.calamityAction.calamityActionNotes[index].canCalamityNote = new CalamityNoteModel();
      let agreements;
      let guarantees;
      let contactMoments;
      let contactWith;
      let judgement;
      let conversationNote;
      let medicalInformation;
      let plan;
      let repatriationPlan;
      note.fields.forEach(el => {
        switch(el.title)
        {
          case MEDICAL_NOTES_FIELDES.AGREEMENT :
          {
            agreements = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.GUARANTEES :
          {
            guarantees = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.CONTACT_MOMENTS :
          {
            contactMoments = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.CONTACT_WITH :
          {
            contactWith = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.JUDGEMENT :
          {
            judgement = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.CONVERSATION_NOTE :
          {
            conversationNote = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.MEDICAL_INFORMATION :
          {
            medicalInformation = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.PLAN :
          {
            plan = el.value;
            break;
          }
          case MEDICAL_NOTES_FIELDES.REPATRIATION_PLAN :
          {
            repatriationPlan = el.value;
            break;
          }
        }
      });
      let clntFreeText = {
        isDependent: true,
        agreements: agreements,
        guarantees: guarantees,
        contactMoments: contactMoments,
        contactWith: contactWith,
        conversationNote: conversationNote,
        judgement: judgement,
        medicalInformation: medicalInformation,
        plan: plan,
        repatriationPlan: repatriationPlan,
      };
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnFreeText = JSON.stringify(clntFreeText);
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnCreatedDate = new Date();
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnLastModifiedDate = new Date();
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnCreatedBy = this.profile.fullName;
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnCalamityId = this.calamityId;
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnId = note.id;
      this.calamityAction.calamityActionNotes[index].canCalamityNoteId = note.id;
      this.calamityAction.calamityActionNotes[index].canCalamityNote.clnNoteTypeId = this.noteTypeList.find(nt => nt.notShortName == "Operations").notId;
      index++;
    });
    this.calamityAction.claFollowUpDate = this.getDate(calamityActionFormValue.claFollowUpDate);
    if (this.calamityActionToUpdate != null && this.calamityActionToUpdate != undefined) {
      this.calamityAction.claId = this.calamityActionToUpdate.claId;
      let historyList : any[] = [];
      historyList = this.calamityActionHistoryService.getfieldsChanged(this.selectedCalamityAction,this.calamityActionForm.value)
      this.calamityAction.calamityActionLogHistories = historyList ;
    }
    let otherItems = JSON.parse(this.calamityAction.claFreeText);
    this.calamityAction.contactWith = otherItems.contactWith;
    this.calamityAction.associatedToHelpPlan = otherItems.associatedToHelpPlan;
    this.calamityAction.comment = otherItems.comment;
    this.calamityAction.helpPlan = otherItems.helpPlan;
    if ( this.selectedCalamityAction != undefined && !! this.selectedCalamityAction.claId){
      this.calamityAction.claId = this.selectedCalamityAction.claId;
      this.calamityAction.claLastModifiedDate = new Date();
      this.calamityAction.claLastModifiedBy = this.profile.fullName;
      this.calamityAction.claCreatedBy = this.selectedCalamityAction.claCreatedBy;
      this.calamityAction.claCreatedDate = this.getDate(this.selectedCalamityAction.claCreatedDate);
      this.calamityActionService
      .update(this.calamityAction)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dialog.close(this.calamityAction);
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.UPDATE_CALAMITY_ACTION");
      });

    } else {
      this.calamityAction.claCreatedBy = this.profile.fullName;
      this.calamityAction.claCreatedDate = new Date();
      this.calamityActionService
      .save(this.calamityAction)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dialog.close(this.calamityAction);
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.INSERT_CALAMITY_ACTION");
      });
    }
  }

  getNoteTypeListByRole() {
    this.noteTypeService
      .getAll(true)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.noteTypeList = data;
      },
      (error) => {
          this.cedNotificationService.error("NOTIFICATIONS.NOTE_TYPES_BY_ROLES");
      });
  }

  public cancel(): void {
    this.dialog.close();
    this.addAction = false;
  }
  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }

}
